import dayjs from 'dayjs';



export const getReminderDate = (expirationDate, offset) => {
    const remDate = dayjs(expirationDate).subtract(offset, 'week');
    return rollToNextBusinessDay(remDate);
}

export const rollToNextBusinessDay = (reminderDate) => {
    // isoWeek doesn't seem to work...
    //    dayjs.extend(isoWeek);

    // const dayOfWeek = reminderDate.isoWeekday();
    const dayOfWeek = reminderDate.day();
    var daysToAdd;
    switch(dayOfWeek) {
        case 6:
            // Saturday
            daysToAdd = 2;
            break;
        case 0:
            // Sunday
            daysToAdd = 1;
            break;
        default:
            daysToAdd = 0;
    }

    return reminderDate.add(daysToAdd, 'day');
}
